import React from 'react';
import { MustIncludeOneOfBasicTestIdWithIdProps } from '../common/internal/test-id.types';
import HBBaseFormField, {
    HBBaseFormFieldProps,
    splitFieldProps
} from '../HBBaseFormField/HBBaseFormField';
import HBRadioButtonGroup, {
    HBRadioButtonGroupProps
} from '../HBRadioButtonGroup/HBRadioButtonGroup';

export interface HBRadioButtonGroupFieldProps<Value extends string | number>
    extends Omit<
        HBRadioButtonGroupProps<Value> & HBBaseFormFieldProps,
        'testIdName'
    > {
    /** HTML id for the field; used as the htmlFor target on the label. */
    id: string;
    /** Test ID identifier for the group container and each option as {testIdName}-{value}. Overrides the id-based default. */
    testIdName?: string;
}

const HBRadioButtonGroupField = <Value extends string | number>(
    props: HBRadioButtonGroupFieldProps<Value> &
        MustIncludeOneOfBasicTestIdWithIdProps
) => {
    const {
        fieldProps,
        inputProps: { testIdName, ...inputProps }
    } = splitFieldProps(props);

    return (
        <HBBaseFormField {...fieldProps}>
            <HBRadioButtonGroup {...inputProps} testIdName={testIdName} />
        </HBBaseFormField>
    );
};

export default HBRadioButtonGroupField;
